import React from 'react';
import { Link } from 'react-router-dom';

const FallbackPage = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-900 text-white">
      <h1 className="text-4xl font-bold mb-4">404 - Page Not Found</h1>
      <p className="text-lg">The page you&apos;re looking for does not exist.</p>
      <Link className="text-blue-400 hover:text-blue-300 mt-4" to="/">
        {' '}
        Go Home
      </Link>
    </div>
  );
};

export default FallbackPage;
